// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","wrapper":"MarketSpotlightNavigator_wrapper__fFH9s","moreDetails":"MarketSpotlightNavigator_moreDetails__sOgRE"};